import { useScrollReveal } from "@/hooks/useScrollReveal";
import { differentials } from "@/mocks/services";

export default function Differentials() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="py-20 md:py-32 bg-background-950">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 md:px-10 transition-all duration-1000 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="max-w-2xl mb-16">
          <p className="flex items-center gap-3 font-label text-[11px] md:text-xs uppercase tracking-[0.3em] text-primary-300 mb-6">
            <span className="w-10 h-[1px] bg-primary-400/70" />
            Por que escolher
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-5 leading-tight">
            O Studio Jennifer Siqueira
          </h2>
          <p className="text-background-100/65 text-sm md:text-base font-light leading-relaxed">
            Cada detalhe foi pensado para oferecer uma experiência de beleza
            verdadeiramente excepcional
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-primary-500/15 border border-primary-500/15 rounded-2xl overflow-hidden">
          {differentials.map((item, i) => (
            <div
              key={item.id}
              className="group bg-background-950 p-7 md:p-8 transition-colors duration-500 hover:bg-background-900"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-14 h-14 mb-6 rounded-full border border-primary-500/30 flex items-center justify-center text-primary-300 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-950 group-hover:border-primary-500">
                <i className={`${item.icon} text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-background-50 mb-3">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-background-100/60 font-light leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}